// extracted by mini-css-extract-plugin
module.exports = {"comp":"SectionH_comp__nT3hs","title":"SectionH_title__5uT8K"};